import React, { Component } from "react";
import Link from "next/link";
import { NotFound } from "../../src/components/common/NotFound";
import { fetchAllBlog } from "../../src/store/actions";

class EducationAndTraining extends Component {
  static async getInitialProps(ctx) {
    try {
      const gvJobs = await ctx.store.dispatch(
        fetchAllBlog({ type: "education-and-trainings" })
      );
      return {
        title: "Rojgarisanjal Government Jobs",
        meta_desc:
          "RojgariSanjal, a free  job portal, is a modern name for an online job platform that acts as a mediator between job seekers and employers, As the name  Rojgari Sanjal.",
        keywords:
          "what is rojgari sanjal, modern job portal, employee and employers meeting platform, free job platform,  Post free Vacancy in Nepal,Free job portal in Nepal, job posting site in nepal, best job portal in nepal, no1 job portal in nepal, large job portal in nepal, find employee in nepal, how to post vacancy in Nepal, post job ads in nepal, post vacancy in nepal",
        showFooter: true,
        data: gvJobs && gvJobs.data ? gvJobs.data.data : [],
      };
    } catch (e) {
      console.log(e.response);
    }
  }
  render() {
    const { data } = this.props;

    return (
      <div>
        <div className="tr-breadcrumb bg-image section-before jobs-listing">
          <div className="container">
            <div className="breadcrumb-info text-center">
              <h2>{"Education & Trainings".toUpperCase()}</h2>

              <ul className="job-meta tr-list list-inline">
                <li>
                  <Link href={"/"}>
                    <a href={""}>
                      <i className="fas fa-home" />
                      {"Rojgari Sanjal"}
                    </a>
                  </Link>
                  &nbsp;&nbsp;
                  <i className="fas fa-chevron-right" />
                  <span style={{ color: "#ccc" }}>Education & Trainings</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="job-list-container">
          <div className="container-fluid">
            <div className="blog_grid_box_container">
              <div className="row">
                {data.length < 1 ? <NotFound /> : null}

                {data.map((item, key) => {
                  return (
                    <div className="col-lg-3 col-md-6" key={key}>
                      <div className="blog_grid_box">
                        <figure>
                          <img
                            src={`${item.image}`}
                            onError={(e) => {
                              e.target.src =
                                "https://www.worldloppet.com/wp-content/uploads/2018/10/no-img-placeholder.png";
                            }}
                            className="img-fluid"
                            alt="Responsive image"
                          />
                        </figure>
                        <div className="blog_grid_content">
                          <h1>{item.title} </h1>
                          {/* <p>2020-09-26 23:00:15 By <strong>admin </strong></p> */}
                          <p>{item.short_desc}</p>

                          <Link
                            href={`/education-and-training/details/${item.slug}-${item.id}`}
                            as={`/education-and-training/details/${item.slug}-${item.id}`}
                          >
                            <a
                              href={`/education-and-training/details/${item.slug}-${item.id}`}
                              className="btn btn-success btn-block view_more"
                            >
                              View Details
                            </a>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EducationAndTraining;
